import { createAction, props } from '@ngrx/store';
import { LoadDataParams } from '../../interfaces/DataSource/DataSourceParams.interface';

export const loadData = createAction(
  '[Data] Load',
  props<LoadDataParams>()
);

export const loadDataSuccess = createAction(
  '[Data] Load Success',
  props<{ dataSourceKey: string; data: any; settings: any }>()
);

export const loadDataFailure = createAction(
  '[Data] Load Failure',
  props<{ dataSourceKey: string; error: any }>()
);

export const clearData = createAction(
  '[Data] Clear',
  props<{ dataSourceKey: string }>()
);

export const clearAllData = createAction('[Data] Clear All');

export const refreshData = createAction('[Data] Refresh Data'); 